<template>
  <div class="max-w-4xl mx-auto">
    <div class="bg-white rounded-lg shadow-md p-8">
      <div class="text-center">
        <h1 class="text-3xl font-bold text-gray-900 mb-4">Set Lab Defaults</h1>
        <div class="mt-8 p-6 bg-yellow-50 border border-yellow-200 rounded-lg">
          <svg class="mx-auto h-12 w-12 text-yellow-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          <p class="text-lg font-medium text-gray-900">Set Lab Defaults Under Development</p>
          <p class="mt-2 text-sm text-gray-600">
            Lab default settings and configuration features are currently under development.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetLabDefaults',
  inject: ['hideBackButton'],
  mounted() {
    this.hideBackButton()
  }
}
</script>

